export default "__VITE_ASSET__CbC0VtNi__"